<template>
	<div class="title-box" :class="{'title-fixed': noVip}">
		<div class="titles clearfix" :class="{'newV-titles': noVip}">
			<span class="fl tit-logo" :class="{'newV-tit-logo': noVip}"></span>
			<span class="newV-tit-text" v-if="noVip"></span>
			<!-- <span class="job-trust" @click="handleSkipPage" :class="{'color-text': !noVip}">求职诚信+</span> -->
			<div class="fr clearfix tit-userMes">
				<a class="tit-icon-login fl" v-if="vipState==='loginNo'" @click="toLogin('https://cvip.58.com/view/pc','pc-cvip-topbar-dl')">登录</a>
				<div class="fl" v-else>
					<div class="tit-icon fl">
						<span class="tit-vip" v-if="vipState===1 || vipState===10"></span>
						<img :src="'//pic1.58cdn.com.cn' + userInfo.profile" v-if="userInfo.profile">
						<img src="//img.58cdn.com.cn/ui6/my/images/touxiang_default.gif" v-else>
					</div>
					<span class="tit-name fl" :class="{'newV-tit-my': noVip}">{{userInfo.nickname}}</span>
				</div>
				<a class="tit-my fl" :class="{'newV-tit-my': noVip}" @click="toLogin('https://my.58.com/pro/myjob/index','pc-cvip-topbar-wdqz')">我的求职</a>
				<a class="tit-my fl" :class="{'newV-tit-my': noVip}" @click="toLogin('https://my.58.com/index','pc-cvip-topbar-grzx')">个人中心</a>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getUserMes } from '../../../../api/index.js'
export default {
	name: 'titles',
	props: ['vipState'],
	data(){
		return {
			noVip: false
		}
	},
	mounted() {
		// 非会员
		if(this.vipState === 0 || this.vipState === 'loginNo'){
			this.noVip = true
		}
	},
	methods: {
		handleSkipPage() {
			window.clickLog && window.clickLog(`from=cvip-job-trust`);
			// window.open("https://certify.58.com/self/index?utm_source=cvip-pctopbar");
			window.location.href = "https://certify.58.com/self/index?utm_source=cvip-pctopbar"
		},
		toLogin(path,log){
			window.clickLog && window.clickLog(`from=${log}`);
			window.location.href = `https://passport.58.com/v2/login?appid=wxa9a9dec97e6ee639&source=58-applet-pc&path=${encodeURIComponent(path)}`
		}
	},
	computed: mapGetters({
		userInfo: 'userInfo'
	})
}
</script>

<style lang="scss" scope>
	.title-box{
		width: 100%;
		height: 70px;
		background: transparent;
	}
	.titles {
		width: 1190px;
		height: 34px;
		padding: 18px 0;
		margin: 0 auto;
		background: #fff;
	}
	.tit-logo {
		width: 296px;
		height: 34px;
		background: url(../../../../assets/imgs/tit-logo.png);
		background-size: 296px 34px;
	}
	.tit-userMes {
		font-size: 14px;
		color: #B89860;
	}
	.tit-icon-login {
		display: inline-block;
    	margin: 7px 20px 0;
		margin-right: 20px;
		opacity: .9;
		font-size: 14px;
		color: #FFFFFF;
		&:hover {
			opacity: 1;
		}
	}
	.tit-icon {
		position: relative;
		display: inline-block;
		width: 38px;
		height: 38px;
		// overflow: hidden;
		margin-right: 13px;
		// border-radius: 19px;
		img {
			width: 38px;
			height: 38px;
			border-radius: 50%;
		}
	}
	.tit-vip {
		position: absolute;
		right: -2px;
		bottom: -2px;
		display: inline-block;
		width: 50px;
		height: 50px;
		background: url(../../../../assets/imgs/tit-userImg.png);
		background-size: 50px 50px;
	}
	.tit-name {
		position: relative;
		margin-top: 7px;
		padding-right: 20px;
		opacity: .9;
	}
	/* .tit-name:after {
		content: "";
		position: absolute;
		top: 7px;
		right: 24px;
		width: 10px;
		height: 6px;
		background: url(../../../../assets/imgs/tit-bottomArrow.png);
		background-size: 10px 6px;
	} */
	.tit-nameTop:after {
		content: "";
		position: absolute;
		top: 7px;
		right: 24px;
		width: 10px;
		height: 6px;
		background: url(../../../../assets/imgs/tit-topArrow.png);
		background-size: 10px 6px;
	}
	.tit-my {
		position: relative;
		display: inline-block;
		margin: 7px 20px 0;
		opacity: .9;
		&:hover {
			opacity: 1;
		}
	}
	.newV-tit-my{
		font-size: 14px;
		color: #FFFFFF;
	}
	.tit-my:after {
		content: "";
		position: absolute;
		top: 4px;
		left: -20px;
		right: 0;
		width: 1px;
		height: 14px;
		background: #D8D8D8;
	}
	.newV-tit-my:after{
		height: 10px;
		top: 5px;
		opacity: 0.3;
		background: #FFFFFF;
	}

	//新版非会员样式
	.title-fixed {
		position: fixed;
		top: 0;
		z-index: 9999;
	}
	.newV-titles {
		background: transparent;
	}
	.newV-tit-logo{
		width: 190px;
		background: url(../../../../assets/imgs/logo.png) no-repeat ;
		background-size: 170px 34px;	
	}
	.newV-tit-text{
		display: inline-block;
		width: 120px;
		height: 34px;
		float: left;
		background: url(../../../../assets/imgs/tit-text.png) no-repeat ;
		background-size: 100% 100%;
	}
	.job-trust {
		display: inline-block;
		position: relative;
		margin-left: 38px;
		cursor: pointer;
		font-size: 16px;
		color: #FFFFFF;
		letter-spacing: 0;
		text-align: center;
		line-height: 36px;
		&.color-text {
			color: #333;
		}
		&::after {
			content: "";
			display: inline-block;
			width: 36px;
			height: 19px;
			background: url(../../../../assets/imgs/tit-text-trust.png) no-repeat center;
			background-size: 100% 100%;
			position: absolute;
			top: -8px;
			right: -28px;
		}
	}
</style>



// WEBPACK FOOTER //
// Title.vue?bd3ea7c8